// extracted by mini-css-extract-plugin
export const details = "details-module--details--3DUy1";
export const html = "details-module--html--LZQUu";
export const featured = "details-module--featured--3FFGN";